import styled from '@emotion/styled';
import React from 'react';
import CheckCircleIcon from '../../svg/ContiUpgrade/CheckCircleIcon';
import { RichTextRenderer } from '../RichTextRenderer';

const StyledContiWrapper = styled.div`
	> div:first-of-type {
		margin: -20px;
	}

	.dmlp__conti-upgrade__cta {
		position: sticky;
		bottom: 0;
		background: white;
		padding: 10px 0 20px;
	}
`;

const StyledContiBenefits = styled.div``;

const ContiUpgradeBenefits = ({ title, copy, brand }) => {
	return (
		<StyledContiBenefits className='d-flex justify-content-start align-items-start mb-20 conti-upgrade__benefit'>
			<div className='mr-12 conti-upgrade__benefit__icon'>
				<CheckCircleIcon
					color={
						brand === 'vir'
							? '#512698'
							: brand === 'adc'
							? '#F15B46'
							: '#117B53'
					}
				/>
			</div>
			<div>
				<div className='subtitle mb-4 lower roboto conti-upgrade__benefit__title'>
					{title}
				</div>
				<div className='conti-upgrade__benefit__copy'>{copy}</div>
			</div>
		</StyledContiBenefits>
	);
};

const ContiUpgrade = ({
	brand = '',
	handleContiUpgrade,
	contiDetails,
	country,
}) => {
	let { video, image, title, ctaCopy, ctaOfferCopy, tc, benefits } =
		contiDetails;
	let contiVideo =
			'https://www.youtube.com/embed/YKR0mGfi9nc?rel=0&controls=0&showinfo=0&enablejsapi=1&origin=https%3A%2F%2Fwww.laithwaites.com.au',
		contiUpgradePrice = '$209.99';

	if (brand === 'wpe') {
		contiVideo =
			'https://www.youtube.com/embed/YKR0mGfi9nc?rel=0&controls=0&showinfo=0&enablejsapi=1&origin=https%3A%2F%2Fwww.laithwaites.com.au';
		contiUpgradePrice = '$209.99';
	} else if (brand === 'adc') {
		contiVideo =
			'https://www.youtube.com/embed/s5p66JbBOss?rel=0&controls=0&showinfo=0&enablejsapi=1&origin=https%3A%2F%2Fwww.theaustralianwine.com.au';
		contiUpgradePrice = '$209.99';
	} else if (brand === 'vir') {
		contiVideo =
			'https://www.youtube.com/embed/bx7JIdy5kCs?rel=0&controls=0&showinfo=0&enablejsapi=1&origin=https%3A%2F%2Fwww.virginwines.com.au';
		contiUpgradePrice = '$179.99';
	} else if (brand === 'law') {
		contiVideo =
			'https://www.youtube.com/embed/bH_zYWlesLs?rel=0&controls=0&showinfo=0&enablejsapi=1&origin=https%3A%2F%2Fwww.laithwaites.co.nz';
		contiUpgradePrice = '$217.88';
	}

	if (video) {
		contiVideo = video;
	}

	let items;
	if (benefits && benefits?.items.length > 0) {
		items = benefits?.items;
	} else {
		items = [
			{
				description:
					'Expertly selected gems - Best-loved styles from top producers & the finest regions.',
				title: '12 Superb Wines',
			},
			{
				description: 'In every future case.',
				title: 'Two Free Bottles worth $36',
			},
			{
				description: 'Don’t like the wine? We’ll give you your money back!',
				title: '100% Satisfaction Guarantee',
			},
			{
				description: `Conveniently delivered for just ${contiUpgradePrice} + P&P every 12 weeks & at Christmas.`,
				title: `Savings of at least 25%`,
			},
			{
				description: 'You’re free to delay or cancel at any time.',
				title: 'No Commitment',
			},
		];

		if (country === 'NZ') {
			let deletedItems = items.splice(1, 1);
		}
	}

	/**
	 * Added Adobe DL event after click on yes or no button
	 */
	const onClickYesOrNoForAdobeDL = (type) => {
		var AdobeDLClickEventObj = {};
		if (type === 'Yes') {
			AdobeDLClickEventObj = {
				clickEvent: 'rec:checkout:ug:popup:yes',
				clickDescription: 'rec:checkout:ug:popup:yes',
				name: 'Click yes on upgrade to wine plan pop up',
				clickLocation: 'rec checkout upgrade',
				clickText: type,
				clickAction: 'Click yes',
			};
		} else {
			AdobeDLClickEventObj = {
				clickEvent: 'rec:checkout:ug:popup:no',
				clickDescription: 'rec:checkout:ug:popup:no',
				name: 'Click no thanks on upgrade to wine plan pop up',
				clickLocation: 'rec checkout upgrade',
				clickText: type,
				clickAction: 'Click no thanks',
			};
		}

		// eslint-disable-next-line no-undef
		AdobeDLFunctions.clickEventDL(
			AdobeDLClickEventObj.clickEvent,
			AdobeDLClickEventObj
		);
	};

	return (
		<StyledContiWrapper>
			<div className='conti-upgrade'>
				<h5 className='font-weight-bold mt-0 mb-20 text-center conti-upgrade__title'>
					{title
						? title
						: 'Want access to delicious wines at fabulous prices every time?'}
				</h5>

				{image ? (
					<div className='mb-20 conti-upgrade__image'>
						<img src={image} alt='Conti Upgrade' className='img-responsive' />
					</div>
				) : (
					<div className='dmlp__conti-upgrade__video conti-upgrade__video mb-20 position-relative'>
						<iframe
							className='w-100 position-absolute h-100'
							src={contiVideo}
							frameBorder='0'
							allowFullScreen
							allow='autoplay'
						></iframe>
					</div>
				)}

				<h5 className='font-weight-bold mt-0 mb-20 text-center lower conti-upgrade__benefits-title'>
					Look forward to more...
				</h5>

				{items.length > 0 ? (
					<StyledContiBenefits>
						{items.map((item, index) => {
							let { title, description } = item;
							if (title && description) {
								return (
									<ContiUpgradeBenefits
										key={index}
										title={title}
										copy={description}
										brand={brand}
									/>
								);
							}
						})}
					</StyledContiBenefits>
				) : null}

				<div className='dmlp__conti-upgrade__cta'>
					{/* <div className='mb-16 dmlp__conti-upgrade__cta__title font-weight-bold text-center'>
						Take a further $30 off today’s price when you sign up now!
					</div> */}
					<button
						type='button'
						className={`btn btn-${
							brand === 'adc' ? 'green' : 'primary'
						} w-100 mb-12 conti-upgrade__yes-btn ${brand}`}
						onClick={() => {
							handleContiUpgrade(true);
							onClickYesOrNoForAdobeDL('Yes');
						}}
					>
						<span className='font-weight-bold d-block pb-4 text-uppercase'>
							{ctaCopy ? ctaCopy : 'Yes Please!'}
						</span>
						<span className='d-block font-weight-normal'>
							{ctaOfferCopy
								? ctaOfferCopy
								: 'Take a further $30 off today’s price'}
						</span>
					</button>
					<div
						className={
							'btn btn-secondary btn-block bg text-center p-12 font-weight-normal conti-upgrade__no-btn ' +
							brand
						}
						onClick={() => {
							handleContiUpgrade(false);
							onClickYesOrNoForAdobeDL('No');
						}}
					>
						No thanks, place my order
					</div>
				</div>

				{/* <div className='dmlp__conti-upgrade__tc-title mb-8 pt-20'>
					Terms & Conditions
				</div> */}
				<div className='dmlp__conti-upgrade__tc mb-20'>
					{tc?.content && tc?.content.length > 0 ? (
						<RichTextRenderer content={tc} />
					) : (
						<div>
							By clicking yes today and saving $30: I understand that
							approximately every 12 weeks, and again at Christmas, I will
							automatically receive my Experts&apos; Choice selection unless I
							request otherwise. Future Experts&apos; Choice deliveries will be{' '}
							{contiUpgradePrice} plus delivery. The credit card that I use to
							pay for today’s introductory case will be charged for all future
							Experts&apos; Choice cases. I am under no commitment whatsoever
							and may cancel at any time. Furthermore, if I do not like a wine
							for any reason it will be collected and I will be refunded in
							full.
						</div>
					)}
				</div>
			</div>
		</StyledContiWrapper>
	);
};

export default ContiUpgrade;
